var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app"},[_c('mpx-keep-alive',[_c('router-view',{staticClass:"page"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }